import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import { schedulePropTypes } from 'constants/propTypes';
import { bem } from 'helpers/class-name';

import Message from 'components/Message';
import PillGraph, { PillGraphLegend } from 'components/PillGraph';
import { Card, CardSection, CardTitle } from 'components/Card';

import { deriveReservationsGraphLegendItems, deriveReservationsGraphData } from '../Insights.helpers';

import ClassReservationsSummaryTable from './ClassReservationsSummaryTable';

import './ClassReservations.scss';

const { block, element } = bem('class-reservations');

const messages = defineMessages({
  body: {
    id: 'yield-management.insights.class-reservations.body',
    defaultMessage: 'Below is a breakdown of the total ClassPass bookings for this class',
  },
  classReservations: {
    id: 'yield-management.insights.class-reservations.class-bookings',
    defaultMessage: 'Class Bookings',
  },
});

const ClassReservations = ({ noDirectFillData, schedule }) => {
  const { spots: { classpassBooked } = {} } = schedule;
  const graphLegendItems = deriveReservationsGraphLegendItems(noDirectFillData);
  const graphData = deriveReservationsGraphData(noDirectFillData, schedule);

  return (
    <Card className={block()} flush>
      <CardSection className="p-r border-b">
        <Message as={CardTitle} message={messages.classReservations} />
      </CardSection>
      <CardSection className={element('details', 'border-b')}>
        <Message as="p" className={element('body', 'mb-h')} message={messages.body} />
        <ClassReservationsSummaryTable classpassBooked={classpassBooked} />
      </CardSection>
      <CardSection className={element('graph-container')}>
        <PillGraph name="class-reservations" data={graphData} className="mh-tiny" large />
        <PillGraphLegend items={graphLegendItems} className="mt-mega" />
      </CardSection>
    </Card>
  );
};

ClassReservations.propTypes = {
  noDirectFillData: PropTypes.bool,
  schedule: PropTypes.shape(schedulePropTypes),
};

export default ClassReservations;
